import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMG } from "@/data/site";
import { Reveal } from "@/components/Reveal";

const CHIPS = ["Palaces", "Jaalis", "Arches", "Lake Landscapes", "Traditional Carving", "Contemporary Luxury"];

export default function Heritage() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      ref={ref}
      id="heritage"
      data-testid="heritage-section"
      className="relative overflow-hidden bg-obsidian py-32 sm:py-44"
    >
      <motion.img
        src={IMG.heritage}
        alt="Udaipur palace architecture"
        style={{ y }}
        className="absolute inset-0 h-[124%] w-full object-cover opacity-40"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-obsidian/80 via-obsidian/40 to-obsidian/85" />
      <div className="relative mx-auto max-w-4xl px-6 text-center sm:px-12">
        <Reveal>
          <div className="flex items-center justify-center gap-4">
            <span className="hairline" />
            <span className="eyebrow-light">Udaipur Heritage</span>
            <span className="hairline" />
          </div>
          <h2 className="mt-6 font-serif text-3xl font-medium leading-tight text-stone-100 sm:text-5xl lg:text-6xl">
            Inspired by Udaipur.
            <span className="gold-grad-text block italic">Crafted for the World.</span>
          </h2>
          <p className="mt-4 font-script text-2xl text-gold-soft/90 sm:text-3xl">
            Inspired by Nature, Built for Generations
          </p>
          <p className="mx-auto mt-6 max-w-xl text-sm leading-relaxed text-stone-300 sm:text-base">
            Centuries of Rajasthani carving — palace jaalis, arches and lake-city silhouettes —
            quietly reimagined for contemporary luxury spaces.
          </p>
          <div className="mt-10 flex flex-wrap justify-center gap-3">
            {CHIPS.map((c) => (
              <span
                key={c}
                className="rounded-full border border-gold/30 bg-obsidian/50 px-4 py-2 text-[11px] uppercase tracking-[0.2em] text-gold-soft backdrop-blur-sm"
              >
                {c}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
